import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const HelpCloudIllustration = ({ width = 784, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 784 361">
      <defs>
        <path id="02y87jrqma" d="M0.729 0.321L50.051 0.321 50.051 49.479 0.729 49.479z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#F4F4F4"
          d="M28.01 184.15c-7.888-12.037-12.489-26.416-12.489-41.878 0-42.282 34.302-76.561 76.615-76.561 16.054 0 30.948 4.945 43.26 13.379 19.309-22.878 48.187-37.423 80.481-37.423 58.127 0 105.248 47.09 105.248 105.18 0 13.145-2.434 25.716-6.842 37.318 33.029 8.51 57.432 38.478 57.432 74.142 0 42.282-34.302 76.561-76.613 76.561-12.387 0-24.076-2.955-34.43-8.172-13.783 20.263-37.033 33.573-63.397 33.573-15.368 0-29.67-4.54-41.663-12.324-14.96 8.16-32.118 12.805-50.363 12.805C47.121 360.75 0 313.66 0 255.57c0-27.577 10.634-52.663 28.01-71.42"
        />
        <path
          fill="#FFBE03"
          d="M243.424 204.495c0-40.274-32.648-72.915-72.918-72.915-40.274 0-72.917 32.644-72.917 72.915 0 40.283 32.643 72.918 72.917 72.92 14.144 0 27.336-4.037 38.516-11.008l31.968 8.567-8.567-31.972c6.965-11.172 11-24.367 11-38.507"
        />
        <path
          fill="#000"
          d="M169.958 131.58V277.415c14.25 0 27.541-4.037 38.804-11.006l32.212 8.565-8.633-31.972c7.017-11.172 11.083-24.367 11.083-38.507 0-40.274-32.893-72.915-73.466-72.915"
          opacity=".1"
        />
        <path
          fill="#000500"
          d="M170.333 245.617h-.112c-5.826 0-9.784-4.418-9.784-10.307 0-6.116 4.07-10.31 9.784-10.31 5.939 0 9.789 4.194 9.898 10.31 0 5.89-3.85 10.307-9.786 10.307zm7.586-26.053h-14.513l-.221-2.944c-.218-5.776 1.54-11.666 6.49-17.784 3.516-4.303 6.377-8.041 6.377-11.78 0-3.963-2.532-6.682-7.917-6.796-3.74 0-8.027 1.247-10.996 3.399l-3.629-12.345c3.958-2.38 10.446-4.645 18.363-4.645 14.404 0 21.112 8.269 21.112 17.555 0 8.725-5.28 14.387-9.46 19.144-3.957 4.645-5.714 9.062-5.606 14.157v2.04z"
        />
        <path
          fill="#F4F4F4"
          d="M402.417 161.735c0 36.64 29.702 66.338 66.338 66.338 36.639 0 66.339-29.699 66.339-66.338 0-36.64-29.7-66.34-66.339-66.34-36.636 0-66.338 29.7-66.338 66.34M598.69 174.344c0 21.197 17.183 38.378 38.377 38.378 21.196 0 38.38-17.18 38.38-38.378 0-21.195-17.184-38.378-38.38-38.378-21.194 0-38.376 17.183-38.376 38.378M721.5 123.358c0 17.259 13.99 31.249 31.249 31.249 17.26 0 31.251-13.99 31.251-31.25 0-17.26-13.99-31.25-31.251-31.25-17.26 0-31.25 13.99-31.25 31.25"
        />
        <g transform="translate(683.122)">
          <path
            fill="#F4F4F4"
            d="M.729 24.899c0 13.576 11.042 24.58 24.662 24.58s24.66-11.004 24.66-24.58c0-13.574-11.04-24.58-24.66-24.58C11.771.319.729 11.325.729 24.899"
          />
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
